module.exports = __webpack_public_path__ + "img/icon-1.31e94ab4.png";